import { defineMessages } from "react-intl";

export const messages = defineMessages({
  pageTitle: {
    id: "MyuvtT",
    defaultMessage: "Export to Google",
    description: "export overview page title",
  },
  channelTitle: {
    id: "q7XzVE",
    defaultMessage: "Channel",
    description: "channel selector card title",
  },
  channelDescription: {
    id: "CBAQV6",
    defaultMessage:
      "Google feeds are per-channel. Pick the channel whose published products you want to export.",
    description: "channel selector card description",
  },
  storefrontUrlLabel: {
    id: "vuk2/A",
    defaultMessage: "Storefront URL",
    description: "storefront url label",
  },
  storefrontUrlHelp: {
    id: "EyEsk3",
    defaultMessage:
      "Base URL of your storefront, used to build each product link (e.g. https://shop.example.com).",
    description: "storefront url help",
  },
  feedUrlTitle: {
    id: "mCigD4",
    defaultMessage: "Crawlable feed URL",
    description: "feed url card title",
  },
  feedUrlDescription: {
    id: "X8K910",
    defaultMessage:
      "Run a push below to generate your feed URL. Add it as a scheduled fetch in Google Merchant Center — Google then re-crawls it on a schedule and keeps your catalogue in sync automatically.",
    description: "feed url card description",
  },
  feedUrlPending: {
    id: "ybCovw",
    defaultMessage: "Push to Google to generate the feed URL.",
    description: "feed url empty placeholder",
  },
  copyUrl: {
    id: "ixM7h6",
    defaultMessage: "Copy URL",
    description: "copy feed url button",
  },
  openUrl: {
    id: "XZvom1",
    defaultMessage: "Open feed",
    description: "open feed url button",
  },
  copied: {
    id: "o3tp7J",
    defaultMessage: "Feed URL copied to clipboard",
    description: "feed url copied toast",
  },
  pushTitle: {
    id: "SjMhhv",
    defaultMessage: "Push now via Content API",
    description: "push card title",
  },
  pushDescription: {
    id: "qZ7H9o",
    defaultMessage:
      "Push the selected channel's products to Google Merchant Center immediately. You supply a service account key each time — it is never stored.",
    description: "push card description",
  },
  pushButton: {
    id: "hFabIi",
    defaultMessage: "Push to Google Merchant Center",
    description: "open push modal button",
  },
});
